import { useContext, useState } from 'react';
import { ContactInfoFormAppConfigContext } from '../components/ContactInfoFormAppConfigContext';

/**
 * The user's "save this to your profile?" answer for the field being validated,
 * read out of the vapService form fields via the field name on the form app
 * context. Undefined outside a form app, where there is no context.
 *
 * PORT NOTE: in the class this was a *field initializer*, so it was evaluated
 * once when the instance was constructed and never recomputed, even as the form
 * fields changed underneath it. The lazy useState initializer below preserves
 * that exactly rather than quietly making the read live.
 *
 * Worth a second look in review: onSubmit and onEditClick both read this, and a
 * user who edits and re-validates within the same mount gets the stale answer.
 * A live read is probably what was intended, but that is a behaviour change and
 * does not belong in a port.
 *
 * PORT NOTE: the class indexed `vapServiceFormFields[fieldName]` without a
 * guard. It only got away with it because the `fieldName &&` short-circuit
 * happens to cover the case where neither exists.
 */
export const useUpdateProfileChoice = ({ vapServiceFormFields } = {}) => {
  const { fieldName } = useContext(ContactInfoFormAppConfigContext) ?? {};

  const [updateProfileChoice] = useState(
    () =>
      fieldName &&
      vapServiceFormFields?.[fieldName]?.value?.updateProfileChoice,
  );

  return updateProfileChoice;
};
